import { motion } from "framer-motion";
import { Award, Clock, Users, Shield, ThumbsUp, BadgeCheck } from "lucide-react";

const WhyChooseUsSection = () => {
  const badges = [
    { icon: BadgeCheck, title: "Fully Qualified", subtitle: "Team" },
    { icon: Clock, title: "Experienced", subtitle: "Professionals" },
    { icon: Users, title: "Friendly Local", subtitle: "Service" },
    { icon: ThumbsUp, title: "Free Affordable", subtitle: "Quotes" },
    { icon: Award, title: "Quality", subtitle: "Workmanship" },
    { icon: Shield, title: "Fully", subtitle: "Insured" },
  ];

  return (
    <section className="py-16 md:py-24 bg-[#1A4D2E]" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#D97706] mb-4 block">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            The Pioneer Difference
          </h2>
        </motion.div>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8">
          {badges.map((badge, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="trust-badge"
              data-testid={`trust-badge-${index}`}
            >
              <div className="icon-circle bg-white/10">
                <badge.icon className="w-8 h-8 text-[#D97706]" />
              </div>
              <h3 className="font-heading text-lg font-bold text-white">
                {badge.title}
              </h3>
              <p className="text-white/70 text-sm">{badge.subtitle}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
